import {
  TablePage,
} from 'src/views/abi/pgaflag'
import pathMap from 'src/paths/pathMap'

class AbiPgaFlagCodeRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_PGA_FLAG_CODE_PATH,
        component: TablePage
      }
    ]
  }
}

export default AbiPgaFlagCodeRoute
